import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { gql, useQuery } from '@apollo/client';
import Page from '../../atoms/Page';
import DeviceCard from '../../organisms/DeviceCard/DeviceCard';

const DEVICE_GQL = gql`
  query DeviceQuery($barnId: uuid!) {
    feed_line_devices: device(
      where: { device_assignments: { ended_at: { _is_null: true }, feed_line: { farm_id: { _eq: $barnId } } } }
      order_by: { serial: desc }
    ) {
      id
      serial
      type
    }

    bin_devices: device(
      where: { bin_controller: { deleted_at: { _is_null: true }, bin_set: { farm_id: { _eq: $barnId } } } }
      order_by: { serial: desc }
    ) {
      id
      serial
      type
    }
  }
`;

function DeviceTab({ titleSegments = [], barnId = null }) {
  const { loading, error, data } = useQuery(DEVICE_GQL, {
    variables: { barnId },
    context: {
      headers: {
        'x-hasura-role': 'user',
      },
    },
  });
  const pageTitleSegments = useMemo(() => ['Devices', ...titleSegments], []);

  if (error) return <span>Error {JSON.stringify(error)}</span>;
  if (loading) return <span>Loading...</span>;

  const feedLineDevices = data?.feed_line_devices || [];
  const binDevices = data?.bin_devices || [];

  const feedLineCards = feedLineDevices.map((device) => (
    <DeviceCard key={device.id} serial={device.serial} deviceId={device.id} />
  ));

  const binCards = binDevices.map((device) => (
    <DeviceCard key={device.id} serial={device.serial} deviceId={device.id} />
  ));

  return (
    <Page className="DevicePage" titleSegments={pageTitleSegments}>
      <div className="DeviceTab">
        <div className="DeviceTab-section">
          <h2 className="DeviceTab-sectionHeading">Feed Line Devices</h2>
          {feedLineCards.length > 0 ? (
            <div className="DeviceCardHolder">{feedLineCards}</div>
          ) : (
            <div className="DeviceTab-emptyState">No Feed Line devices found</div>
          )}
        </div>
        <div className="DeviceTab-section">
          <h2 className="DeviceTab-sectionHeading">Bin Controller Devices</h2>
          {binCards.length > 0 ? (
            <div className="DeviceCardHolder">{binCards}</div>
          ) : (
            <div className="DeviceTab-emptyState">No Bin Controller devices found</div>
          )}
        </div>
      </div>
    </Page>
  );
}

DeviceTab.propTypes = {
  titleSegments: PropTypes.arrayOf(PropTypes.string),
  barnId: PropTypes.string,
};

export default DeviceTab;
